const PROMPT_TEMPLATES: Record<string, string> = {
  upperClothing: "Change the {gender}'s upper clothing to {placeholder}",
  hairStyle: "Change the {gender}'s hair style to {placeholder}",
  clothing: "Change the {gender}'s clothing to {placeholder}",
  hairColor: "Change the {gender}'s hair color to {placeholder}",
  facialHairStyle: "Change the {gender}'s facial hair style to {placeholder}",
};

const DEFAULT_TEMPLATE = "{placeholder}";

export const getFormattedPrompt = (
  category: string,
  wildcard: string,
  gender: string,
  color?: string | null
) => {
  let processedWildcard = wildcard;

  if (wildcard.includes("{color}")) {
    processedWildcard = wildcard.replace("{color}", color || "");
  }

  const template = PROMPT_TEMPLATES[category] ?? DEFAULT_TEMPLATE;
  return template
    .replace("{gender}", gender)
    .replace("{placeholder}", processedWildcard);
};

export const PROMPT_TEMPLATE_KEYS = Object.keys(PROMPT_TEMPLATES);
